import React from 'react';

import classNames from './style.module.scss';
import errorImage from '../../../assets/images/error.png';
import routes from '../../../utils/routes';

interface Props {
	error: Error;
}

const Error: React.FC<Props> = ({ error }) => {
	const navigateHome = () => {
		window.location.href = routes.dashboard.fullPath;
	};

	return (
		<div className={classNames.error}>
			<div className={classNames.errorLeft}>
				<h1>Ooops!</h1>
				<p>
					Looks like something went <strong>wrong</strong> but we'll get this
					resolved in no time!
				</p>

				<div className={classNames.errorStackTrace}>
					<i className="bi bi-exclamation-triangle-fill"></i>
					{error.message}
				</div>

				<button onClick={navigateHome}>Back to Homepage</button>
			</div>

			<div className={classNames.errorRight}>
				<img src={errorImage} alt="Error" loading="lazy" />
			</div>
		</div>
	);
};

export default Error;
